<template>
  <div class="w-100 table card-custom">
    <div class=" position-relative">
      <a class="navigation-text text-center">{{$t('reqList')}} {{nowYear}}</a>
    </div>
    <b-table :items="items" striped :per-page="perPage" small :fields="fields" class="position-relative table">
      <template #cell(actions)="row">
        <a
          v-if="row.item.code === 'R'"
          v-b-tooltip.hover.left
          title="Details"
          class="btn-op icon-info mr-1"
          :href="'/#/new-reimbursement/general' + '/' + row.item.uuid"
        ></a>

        <a
          v-if="row.item.code === 'O'"
          v-b-tooltip.hover.left
          title="Details"
          class="btn-op icon-info mr-1"
          :href="'/#/overtime' + '/' + row.item.uuid"
        ></a>

        <a
          v-if="row.item.code === 'L'"
          v-b-tooltip.hover.left
          title="Details"
          class="btn-op icon-info mr-1"
          :href="'/#/leave' + '/' + row.item.uuid"
        ></a>
      </template>
      <template #cell(createdAt)="row">
        <div class="text-left">
          {{ row.item.createdAt !== null ? getDate(row.item.createdAt) : '-' }}
        </div>
      </template>
      <template #cell(firstName)="row">
        <div class="text-left">
          {{ row.item.requestedBy !== null ? row.item.requestedBy : '-' }}
        </div>
      </template>
      <template #cell(code)="row">
        <div class="text-left align-items-center mt-3">
          <p v-if="row.item.code === 'L'">{{$t('leave')}}</p>
          <p v-if="row.item.code === 'R'">{{$t('reimbursement')}}</p>
          <p v-if="row.item.code === 'O'">{{$t('overtime')}}</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    const nowYear = new Date().getFullYear()
    return {
      nowYear: nowYear,
      apiUrl: {
        requestList: window.AppConfig.apiUrl + 'new-dashboard?requested_year='
      },
      perPage: 10,
      items: [],
      fields: [
        {
          key: 'createdAt',
          label: this.$root.$t('CREATED')
        },
        {
          key: 'firstName',
          label: this.$root.$t('name')
        },
        {
          key: 'code',
          label: this.$root.$t('type'),
          class: ''
        },
        {
          key: 'actions',
          label: 'Detail',
          class: 'text-left',
        },
      ],
    };
  },

  mounted(){
    this.getRequest()
  },

  methods: {
    async getRequest(){
      const resp = await this.$http.get(this.apiUrl.requestList + this.nowYear)
      this.items = resp.data.requested
    },


    getDate(value){
      if(value !==null){
        return this.$moment(value).format("DD MMM YYYY")
      } else {
        return '-'
      }
    }
  }
};
</script>

<style lang="css" scoped>
.table{
  height: 50vh !important;
  overflow-y:scroll !important;
  scrollbar-width: none !important; 
}

</style>